import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './LoginPage.css';

// Icons
const GoogleIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24">
    <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
    <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
    <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
    <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
  </svg>
);

const FacebookIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="#1877F2">
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
  </svg>
);

function LoginPage() {
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });
  const [isLoading, setIsLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    setTimeout(() => {
      console.log('Login attempt:', formData);
      alert('Login submitted! (This is a demo)');
      setIsLoading(false);
    }, 1000);
  };

  const handleGoogleLogin = () => {
    alert('Google login clicked! (This is a demo)');
  };

  const handleFacebookLogin = () => {
    alert('Facebook login clicked! (This is a demo)');
  };

  return (
    <div className="login-page">
      {/* Main Login Container */}
      <div className="login-container">
        {/* Left Panel - Promotional Image */}
        <div className="login-promo-panel">
          {/* This would be an actual image from Ontraport */}
          <img 
            src="https://app.ontraport.com/images/login/promo-webinar.png" 
            alt="Ontraport Webinar Promo"
            className="promo-image"
            onError={(e) => {
              // Fallback if image doesn't load - show placeholder
              e.target.style.display = 'none';
              e.target.parentElement.classList.add('promo-fallback');
            }}
          />
          <div className="promo-fallback-content">
            <span className="promo-label">WEBINAR</span>
            <h2>Make AI part of your marketing strategy in 2026 🤖</h2>
            <p>AI isn't slowing down — and neither should your strategy. Join us live to see how teams are using AI inside Ontraport to personalize at scale and work smarter in the year ahead.</p>
            <button className="promo-cta-btn">Save your spot now</button>
          </div>
        </div>

        {/* Right Panel - Login Form */}
        <div className="login-form-panel">
          {/* Logo */}
          <Link to="/" className="login-logo">
            ontraport
          </Link>

          {/* Social Login Buttons */}
          <div className="social-login-buttons">
            <button className="btn-social-login" onClick={handleGoogleLogin}>
              <GoogleIcon />
              <span>Log in</span>
            </button>
            <button className="btn-social-login" onClick={handleFacebookLogin}>
              <FacebookIcon />
              <span>Log in</span>
            </button>
          </div>

          {/* Divider */}
          <div className="login-divider">
            <span>OR</span>
          </div>

          {/* Login Form */}
          <form className="login-form" onSubmit={handleSubmit}>
            <div className="form-field">
              <input
                type="text"
                name="username"
                className="form-input"
                placeholder="Username"
                value={formData.username}
                onChange={handleInputChange}
                required
              />
            </div>
            <div className="form-field">
              <input
                type="password"
                name="password"
                className="form-input"
                placeholder="Password"
                value={formData.password}
                onChange={handleInputChange}
                required
              />
            </div>

            <a href="/forgot-password" className="forgot-password-link">
              Forgot password?
            </a>

            <button 
              type="submit" 
              className={`btn-login ${isLoading ? 'btn-loading' : ''}`}
              disabled={isLoading}
            >
              {isLoading ? 'Logging in...' : 'Log in'}
            </button>
          </form>

          {/* Sign up link */}
          <Link to="/signup" className="signup-link">
            Sign up for a free trial
          </Link>
        </div>
      </div>

      {/* Bottom Info Section - kept simple like original */}
      <div className="login-info-section">
        <div className="info-card">
          <h3>Join the community</h3>
          <p>Our <a href="https://www.facebook.com/groups/ontraportusers" target="_blank" rel="noopener noreferrer">Facebook User Community</a> is a great place to ask questions and stay updated.</p>
        </div>
        <div className="info-card">
          <h3>Get two months free</h3>
          <p>Switch to a yearly plan and save. After you log in, go to Account &gt; Change plan.</p>
        </div>
        <div className="info-card">
          <h3>Explore our free video courses</h3>
          <p>Learn how to use Ontraport to build your business with <a href="https://ontraportuniversity.com" target="_blank" rel="noopener noreferrer">Ontraport University</a></p>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
